import {
  LIST_CARRIER_PICKUP_LOCATION_REQUEST,
  RESET_CARRIER_PICKUP_LOCATION_QUERY,
  ADD_CARRIER_PICKUP_LOCATION_REQUEST,
  REMOVE_CARRIER_PICKUP_LOCATION_REQUEST
} from './constants';

export const listCarrierPickupLocations = () => ({
  type: LIST_CARRIER_PICKUP_LOCATION_REQUEST
});

export const resetCarrierPickupLocationsQuery = () => ({
  type: RESET_CARRIER_PICKUP_LOCATION_QUERY
});

export const addCarrierPickupLocation = (address, successFunction) => ({
  type: ADD_CARRIER_PICKUP_LOCATION_REQUEST,
  address,
  successFunction
});

export const removeCarrierPickupLocation = (successFunction) => ({
  type: REMOVE_CARRIER_PICKUP_LOCATION_REQUEST,
  successFunction
});
